/**
 * Web Vitals Performance Monitoring
 *
 * Reports Core Web Vitals metrics to console (dev) and backend (prod).
 */
import { onCLS, onFCP, onLCP, onTTFB, onINP, type Metric } from 'web-vitals'

function reportMetric(metric: Metric) {
  // Log to console in development
  if (import.meta.env.DEV) {
    const rating = metric.rating === 'good' ? '✓' : metric.rating === 'needs-improvement' ? '~' : '✗'
    console.log(`[Perf] ${metric.name}: ${metric.value.toFixed(2)} ${rating}`)
  }

  // Send to backend analytics in production
  if (import.meta.env.PROD) {
    const body = JSON.stringify({
      name: metric.name,
      value: metric.value,
      rating: metric.rating,
      delta: metric.delta,
      id: metric.id,
      navigationType: metric.navigationType,
      url: window.location.pathname,
      timestamp: Date.now(),
    })

    // Use sendBeacon if available (doesn't block page unload)
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api/analytics/vitals', body)
    } else {
      fetch('/api/analytics/vitals', {
        method: 'POST',
        body,
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
      }).catch(() => {}) // Silently fail — don't impact UX
    }
  }
}

export function initPerformanceMonitoring() {
  onCLS(reportMetric)  // Cumulative Layout Shift
  onFCP(reportMetric)  // First Contentful Paint
  onLCP(reportMetric)  // Largest Contentful Paint
  onTTFB(reportMetric) // Time to First Byte
  onINP(reportMetric)  // Interaction to Next Paint (replaced FID)
}
